export const environment = {
  production: false,
  baseUrl: 'https://sophiadev.cognida.ai',
  token: '4569595d19c22a0ba8f4879f4db872f05f710585',
  // baseUrl: 'http://localhost:1024',
};
